import { render, staticRenderFns } from "./printMouldEdit.vue?vue&type=template&id=f22b3e48&"
import script from "./printMouldEdit.vue?vue&type=script&lang=js&"
export * from "./printMouldEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports